import React, { useState } from 'react';
import { Upload, Button, message, Card, Typography, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import uploadImg from '../../src/assets/images/Upload1.svg';
import axios from '../util/axiosConfig'; 
import '../../src/styles/upload.css';
import { Link, useLocation } from 'react-router-dom';

const { Title, Text } = Typography;

const UploadPage: React.FC = () => {
  const [file, setFile] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { fromPage } = location.state || {};


  const beforeUpload = (file: any) => {
    setFile(file);
    return false; 
  };

  const handleRemove = () => {
    setFile(null);
  };

  const handleUpload = async () => {
    if (!file) {
      message.warning('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file); 

    setLoading(true);

    try {

      if(fromPage !== "address-list") {
        const response = await axios.post('/uploadFile', formData, {});
         if (response.status === 200) {
          message.success('File uploaded successfully');
          setFile(null);
        } else {
          message.error('File upload failed');
        }
      } else {
        const response = await axios.post('/agreement/upload-agreement', formData, {});
         if (response.status === 200) {
            message.success('File uploaded successfully');
            setFile(null);
            window.location.href = "/address-list";
          } else {
            message.error('File upload failed');
          }
      }

     
    } catch (error) {
      message.error('File upload failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card bordered={false} className='uploadCard'>
      <Title level={2}>Upload INV OCR Pdf</Title>
      <Text type="secondary">Please select Your PDF Files</Text>
      <Card className='uploadSubCard'>
        <Image src={uploadImg} width={200} height={'auto'} preview={false} />
        <Title level={3}>Drag & Drop</Title>
        <Text type="secondary">Your Files here to Upload</Text>
        <Text type="secondary">*Supported Format pdf</Text>
      </Card>
      <div className='upload-container'>
        <Upload
          fileList={file ? [file] : []} 
          onRemove={handleRemove}
          beforeUpload={beforeUpload} 
          accept=".pdf"
          showUploadList={false}
        >
          <Button className="upload-button" icon={<UploadOutlined />}>
            Select File
          </Button>
        </Upload>
        <Button 
          className="upload-button" 
          onClick={handleUpload} 
          loading={loading}
          disabled={!file}
        >
          Click to Upload
        </Button>
      </div>
      { fromPage !== "/address-list" ?
        <Link to={'/invoice-list'} className='backText'>
          Go Back
        </Link> :
        <Link to={'/address-list'} className='backText'>
          Go Back
        </Link>
      }
    </Card>
  );
}

export default UploadPage;
